const Images = {
    LOGO: require("../../assets/img/logo.png"),
    AURA: require("../../assets/img/aura.png"),
    PRODUCT_1: require("../../assets/img/product-1.png"),
    PRODUCT_2: require("../../assets/img/product-2.png"),
    PRODUCT_3: require("../../assets/img/product-3.png"),
    PRODUCT_4_MIN: require("../../assets/img/product-4-min.png"),
    ROULETTE_BG: require("../../assets/img/roulette-bg.png"),
    GIRL_WITH_ELEMENTS: require("../../assets/img/girl-with-elements.png"),
    CELEBRITY_1: require("../../assets/img/celebrity-1.png"),
    CELEBRITY_2: require("../../assets/img/celebrity-2.png"),
    CELEBRITY_3: require("../../assets/img/celebrity-3.png"),
    CELEBRITY_4: require("../../assets/img/celebrity-4.png"),

    M1: require("../../assets/img/m1.png"),
    M2: require("../../assets/img/m2.png"),
    M3: require("../../assets/img/m3.png"),
    M4: require("../../assets/img/m4.png"),
    M5: require("../../assets/img/m5.png"),
    M6: require("../../assets/img/m6.png"),
    M7: require("../../assets/img/m7.png"),
    M8: require("../../assets/img/m8.png"),
    M9: require("../../assets/img/m9.png"),
    M10: require("../../assets/img/m10.png"),
    M11: require("../../assets/img/m11.png"),
    M12: require("../../assets/img/m12.png"),
    M13: require("../../assets/img/m13.png"),
    M14: require("../../assets/img/m14.png"),
    M15: require("../../assets/img/m15.png"),
    M16: require("../../assets/img/m16.png"),
    M17: require("../../assets/img/m17.png"),
    M18: require("../../assets/img/m18.png"),
    M19: require("../../assets/img/m19.png"),
    M20: require("../../assets/img/m20.png"),

    HOTEXCH: require("../../assets/img/hotexch.png"),
    HOTEXCH_10: require("../../assets/img/hotexch10.png"),
    HOTEXCH_15: require("../../assets/img/hotexch15.png"),
    HOTEXCH_20: require("../../assets/img/hotexch20.png"),
    HOTEXCH_25: require("../../assets/img/hotexch25.png"),
    HOTEXCH_30: require("../../assets/img/hotexch30.png"),
    HOTEXCH_40: require("../../assets/img/hotexch40.png"),
    HOTEXCH_50: require("../../assets/img/hotexch50.png"),
    EXTRAEXCH: require("../../assets/img/extraexch.png"),

    SECURE_CONN: require('../../assets/img/pngtree-secure-connection.png'),
    NETBANKING: require('../../assets/img/netBanking.png'),
    TRUSTE_LOGO: require('../../assets/img/Truste_Logo.png'),
    GAMING_CU: require('../../assets/img/gaming-curacao-license.png'),
    SITELOCK: require('../../assets/img/Sitelock-logo.png'),
    MCAFEE: require('../../assets/img/PngItem_3642857.png'),

    APP_STORE: require('../../assets/img/Download_on_the_App_Store_Badge.png'),
    PLAY_STORE: require('../../assets/img/Google_Play_Store_badge_EN.png'),

    WHATSAPP: require('../../assets/img/whatsapp.png'),
    WHATSAPP_ICON: require('../../assets/img/whatsapp-icon.png'),

    OOP_1: require("../../assets/img/oop-1.png"),
    OOP_2: require("../../assets/img/oop-2.png"),
    OOP_3: require("../../assets/img/oop-3.png"),
    OOP_4: require("../../assets/img/oop-4.png"),
    OOP_5: require("../../assets/img/oop-5.png"),
    OOP_6: require("../../assets/img/oop-6.png"),
    OOP_7: require("../../assets/img/oop-7.png"),

    BANNER_1: require("../../assets/img/Banner_1.png"),
    BANNER_2: require("../../assets/img/Banner_2.png"),
    BANNER_3: require("../../assets/img/Banner_3.png"),
    BANNER_4: require("../../assets/img/Banner_4.png"),
    BANNER_5: require("../../assets/img/Banner_5.png"),
    BANNER_6: require("../../assets/img/Banner_6.png"),
    BANNER_7: require("../../assets/img/Banner_7.png"),
    BANNER_8: require("../../assets/img/Banner_8.png"),
    BANNER_9: require("../../assets/img/Banner_9.png"),

    CRICKET: require("../../assets/img/cricket.png"),
    SOCCER: require("../../assets/img/soccer.png"),
    KABADDI: require("../../assets/img/kabaddi.png"),
    TENNIS: require("../../assets/img/tennis.png"),
    POLITICS: require("../../assets/img/politics.png"),
    CUP_WINNER: require("../../assets/img/cup-winner.png"),
}
export default Images